import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import { PLACE_LIST } from '@utils/constants';
import { Row, Col, Input, Button, Select } from 'antd';
import request from '@utils/request';

const InputGroup = Input.Group;
const {Option} = Select;
function ProductFilter(props) {
  const [categoryList, setCategoryList] = useState([]);
  const { isLoading: isLoadingCategoryList, mutate: getCategoryList } = useMutation(() => {
      return request.get('zma/categories');
    },
      {
        onSuccess: (response) => {
          const data = response.data.sort((a, b) => a.name.localeCompare(b.name));
          setCategoryList(data);
          props.onLoadCategoryList(data);
        },
      });
  useEffect(() => {
      getCategoryList();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  const handleChangeInput = e => {
    const { value, dataset } = e.target;
    const { field } = dataset;
    const { onChangeFilter } = props;
    const data = {
      fieldName: field,
      fieldValue: value,
    };
    onChangeFilter(data);
  };
  const handleChangeSelect = fieldName => value => {
    const { onChangeFilter } = props;
    let fieldValue = value;
    const data = {
      fieldName,
      fieldValue,
    };
    onChangeFilter(data);
  };
  const handleChangeCategory = values => {
    const { onChangeFilter } = props;
    let fieldValue = values;
    const data = {
      fieldName: 'category',
      fieldValue,
    };
    onChangeFilter(data);
  };
  const handleChangeBranch = value => {
    const { onChangeFilter } = props;
    const data = {
      fieldName: 'branch',
      fieldValue: value,
    };
    onChangeFilter(data);
  };


  const handleReset = () => {
    props.onChangeFilter({});
    props.onReset();
  };

  const { filter, materialList, patternList, colorList } = props;
  return (
    <Row gutter={8} style={{ marginBottom: 10 }}>
      <Col sm={2}>
        <Input
          data-field="id"
          placeholder="Mã sản phẩm"
          value={filter.id}
          onChange={handleChangeInput}
        />
      </Col>
      <Col sm={6}>
        <Input
          data-field="name"
          placeholder="Tên sản phẩm"
          value={filter.name}
          onChange={handleChangeInput}
        />
      </Col>
      <Col sm={8}>
        <InputGroup compact>
          <Select
            style={{width: '10%'}}
            data-field="categoryOperator"
            placeholder="In"
            value={filter.categoryOperator || 'in'}
            onChange={handleChangeSelect('categoryOperator')}
          >
            <Option value='in'>+</Option>
            <Option value='notIn'>-</Option>
          </Select>
          <Select
            style={{width: '30%'}}
            data-field="category"
            placeholder="Danh mục"
            value={filter.category || []}
            onChange={handleChangeCategory}
            loading={isLoadingCategoryList}
            mode="multiple"
          >
            {categoryList.map(cat => (
              <Option value={cat.id}>{cat.name}</Option>
            ))}
          </Select>
          <Select
            style={{width: '20%'}}
            data-field="material"
            placeholder="Chất liệu"
            value={filter.material || ''}
            onChange={handleChangeSelect('material')}
          >
            <Option value=''>Chất liệu</Option>
            {materialList.map(m => (
              <Option value={m}>{m}</Option>
            ))}
          </Select>
          <Select
            style={{width: '20%'}}
            data-field="pattern"
            placeholder="Hoạ tiết"
            value={filter.pattern || ''}
            onChange={handleChangeSelect('pattern')}
          >
            <Option value=''>Hoạ tiết</Option>
            {patternList.map(m => (
              <Option value={m}>{m}</Option>
            ))}
          </Select>
          <Select
            style={{width: '20%'}}
            data-field="color"
            placeholder="Màu đầm"
            value={filter.color || ''}
            onChange={handleChangeSelect('color')}
          >
            <Option value=''>Màu đầm</Option>
            {colorList.map(m => (
              <Option value={m}>{m}</Option>
            ))}
          </Select>
        </InputGroup>
      </Col>
      <Col sm={4}>
        <InputGroup compact>
          <Select style={{width: '40%'}} 
            data-field="branch"
            onChange={handleChangeBranch}
            value={filter.branch || ''}
          >
            <Option value=''>Tổng</Option>
            {PLACE_LIST.map(p => (
              <Option key={p.value} value={p.value}>{p.label}</Option>
            ))}
          </Select>
          <Input
            style={{width: '30%'}}
            data-field="fromQuantity"
            placeholder="Từ"
            value={filter.fromQuantity}
            onChange={handleChangeInput}
          />
          <Input
            style={{width: '30%'}}
            data-field="toQuantity"
            placeholder="Đến"
            value={filter.toQuantity}
            onChange={handleChangeInput}
          />
        </InputGroup>
        
      </Col>
      <Col sm={4}>
        <Button onClick={handleReset}>Reset</Button>
      </Col>
    </Row>
  );
}

ProductFilter.propTypes = {
  onChangeFilter: PropTypes.func,
  onReset: PropTypes.func,
  filter: PropTypes.objectOf(PropTypes.any),
  materialList: PropTypes.array,
};

ProductFilter.defaultProps = {
  onChangeFilter: () => { },
  onReset: () => { },
  onLoadCategoryList: () => { },
  filter: {},
  materialList: [],
  patternList: [],
  colorList: [],
};

export default ProductFilter;